import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setTranslocationFile } from '../../reducers/BuildRenderRequestSlice';
import { FileUpload } from '../Common/FileUpload';

export const TranslocationFileUpload = () => {
  const dispatch = useDispatch();
  const { translocationFile } = useSelector((state: RootState) => state.buildRenderRequest);

  return (
    <>
      <span className="field-label" style={{ marginTop: 12, display: 'block' }}>
        Translocation File
        <span
          className="info-icon"
          style={{ marginLeft: 6 }}
          title="Optional. Tab-delimited file (.txt/.tsv) with columns: chr1, start1, end1, chr2, start2, end2, [color_hex]. Also accepts a Severus SV VCF (.vcf) — BND breakend pairs are drawn as arcs."
        >
          i
        </span>
      </span>
      <FileUpload
        file={translocationFile}
        onFileUpdate={f => dispatch(setTranslocationFile(f))}
        accept=".txt,.tsv,.csv,.vcf"
        placeholder="Drag & drop translocation file (optional)"
      />
    </>
  );
};
